import React from "react"
import { getAvailableOptions } from "@/components/ProductDetail/v3/SuperSkuOption/utils"
import SuperSkuOptionButton from "@/components/ProductDetail/v3/SuperSkuOption/SuperSkuOptionButton"
import styles from "@/components/ProductDetail/v3/SuperSkuOption/index.module.scss"

const SuperSkuOptionSetButtons = props => {
  const {
    field = "",
    data = [],
    value = "",
    onChange = () => {},
    availableOptions,
  } = props

  return (
    <div className={styles.superSkuOptionSet}>
      {data.map(option => {
        const isActive = value === option
        const disabled = getAvailableOptions({
          availableOptions,
          option,
          field,
        })
        return (
          <SuperSkuOptionButton
            key={`${field}-${option}`}
            option={option}
            isActive={isActive}
            onClick={onChange}
            disabled={disabled}
          />
        )
      })}
    </div>
  )
}

export default SuperSkuOptionSetButtons
